import i18next from 'i18next'
import languageBundle from '@kirschbaum-development/laravel-translations-loader!@kirschbaum-development/laravel-translations-loader'

// Build the translations object (dunno why but it requires a "translation" key on each language top level)
const translations = {}
const languages = Object.keys(languageBundle)

console.log('🌍 Available languages:', languages);

languages.map(language => {
    translations[language] = {
        translation: languageBundle[language]
    }
})

// console.log('window.locale', window.locale);

i18next.init({
    lng: window.locale,
    fallbackLng: 'fr',
    debug: process.env.MIX_APP_ENV !== 'production',
    resources: translations
});
